<script setup lang="ts">
import { computed } from "vue";
import { useAppInfoStore } from "../stores/appInfoStore.ts";
import OKCancelModal from "./OKCancelModal.vue";

const appVersion = __APP_VERSION__;
const appVersionDisplay = computed(() => {
  const plusIdx = appVersion.indexOf("+");
  return plusIdx === -1 ? appVersion : appVersion.slice(0, plusIdx);
});

const appInfoStore = useAppInfoStore();
</script>

<template>
  <OKCancelModal title="About PO Redistribution" ok-button-text="OK">
    <div class="about-modal-content">
      <div class="about-modal-row">
        <span class="about-modal-label">App Version</span>
        <span class="about-modal-value">v{{ appVersionDisplay }}</span>
      </div>
      <div class="about-modal-row">
        <span class="about-modal-label">API Version</span>
        <span
          class="about-modal-value"
          :class="{ 'about-modal-pending': !appInfoStore.apiVersionDisplay }"
        >
          {{
            appInfoStore.apiVersionDisplay
              ? `v${appInfoStore.apiVersionDisplay}`
              : "Unavailable"
          }}
        </span>
      </div>
    </div>
  </OKCancelModal>
</template>
